import packageJSON from '../../package.json'
import { getDevice, getSession } from 'hooks'
import { TrackingProps } from 'models'
import { getFullPath, getQueryParam, minifyObject } from 'utils'

export const getTrackingConstants = () => {
    const { deviceType, osName } = getDevice()
    const { sid, location } = getSession()
    const mediaId = getQueryParam('mediaId')

    return {
        country: location || undefined,
        device: deviceType,
        mediaId,
        osName,
        sid
    }
}

export const getTrackingConfig = (trackingType: 'INTERACTION' | 'DISPLAY') => {
    const isLocal = process.env.REACT_APP_ENV === 'local'
    const env = isLocal ? 'int' : process.env.REACT_APP_ENV
    const host = `https://pubsub.googleapis.com/v1/projects/betin-data-${env}`
    const topic = `/topics/topic-betin-${trackingType.toLowerCase()}-tracking-${env}:publish`
    let apiKey, filterKey

    if (trackingType === 'INTERACTION') {
        apiKey = process.env.REACT_APP_INTERACTION_TRACKING_API_KEY
        filterKey = process.env.REACT_APP_INTERACTION_TRACKING_FILTER_KEY
    } else {
        apiKey = process.env.REACT_APP_DISPLAY_TRACKING_API_KEY
        filterKey = process.env.REACT_APP_DISPLAY_TRACKING_FILTER_KEY
    }

    return {
        url: `${host}${topic}?key=${apiKey}`,
        filterKey: filterKey || ''
    }
}

/**
 * handleTrackingEvent event handler
 *  - Build the PubSub endpoint
 *  - Send an ordered message to the topic
 **/
export const sendTrackingEvent = async ({
    cid = 'bs-rp-0',
    cUid,
    eventType,
    actionType,
    operator = 'GENYBET',
    betType = 'S',
    formulaKey = 'UNIT'
}: Pick<
    TrackingProps,
    | 'cid'
    | 'cUid'
    | 'eventType'
    | 'actionType'
    | 'operator'
    | 'betType'
    | 'formulaKey'
>) => {
    const { device, sid, country, osName, mediaId } = getTrackingConstants()

    if (!mediaId || !sid || !country || !cUid) return
    const trackingType = actionType ? 'INTERACTION' : 'DISPLAY'
    const { url, filterKey } = getTrackingConfig(trackingType)

    let event: TrackingProps = {
        ts: new Date().getTime(),
        m: mediaId,
        cid,
        cUid,
        p: getFullPath(),
        sid,
        device,
        country,
        index: 0,
        // We use existing fields to pass the tracking data
        boids: [betType],
        boUids: [formulaKey],
        operators: [operator]
    }

    if (trackingType === 'INTERACTION') {
        event = {
            ...event,
            eventType,
            actionType,
            appVersion: packageJSON.version,
            osVersion: osName
        }
    }

    const messages = [
        {
            data: minifyObject(event),
            attributes: {
                filterKey
            }
        }
    ]
    const headers = { 'Content-Type': 'application/json' }

    console.debug('[BETSLIP] sendTrackingEvent()', eventType, actionType, {
        event,
        url,
        messages,
        headers
    })

    return await fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify({ messages })
    })
}
